import type { UserQuestListDto } from './userQuest.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationSchema } from '../types/Pagination.types';
import { UserQuestDtoSchema } from './userQuest.schema';

export const questsApi = {
  async getMeQuests(params?: Record<string, unknown>) {
    const response = await httpClient.get<UserQuestListDto>(
      ENDPOINTS.gamification.userQuests.me,
      { params },
    );

    return validateWithZod(PaginationSchema(UserQuestDtoSchema), response);
  },
};
